
// fragment shader that uses the mask texture to display certain areas of the given texture
export const fragment = `
precision highp float;

uniform sampler2D mask;
uniform sampler2D texture;

varying vec2 v_uv;

void main() {
    float alpha = texture2D(mask, v_uv).a;
    vec3 color = texture2D(texture, v_uv).rgb;
    gl_FragColor = vec4(color, alpha);
}
`;